import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { ChipSelectOption } from '@components/ChipSelectOption/ChipSelectOption';
import { RootState } from '@lib/redux.lib/store';
import {
  JOB_POST_STATUS_OPTIONS,
  JobPostStatusType,
} from '@lib/utils/constants/applicationConstants';
import { useJobsBoardFiltersModalContext } from '@views/jobsBoard/JobsBoardSection/JobsBoardFilters/JobsBoardFiltersModal/context';

import { FilterCollapse } from '../components/FilterCollapse';
import { StyledChipsContainer } from '../styles';

export const JobPostStatusFilter = () => {
  const { modalFilters, toggleApplicationStatus } =
    useJobsBoardFiltersModalContext();

  const subtitle = useMemo(() => {
    if (!modalFilters?.applicationStatuses?.length) {
      return 'Any';
    }

    return JOB_POST_STATUS_OPTIONS.filter((jobPostStatus) =>
      modalFilters?.applicationStatuses?.includes(jobPostStatus.value)
    )
      .map((jobPostStatus) => jobPostStatus.label)
      .join(', ');
  }, [modalFilters?.applicationStatuses]);

  return (
    <FilterCollapse
      title={'Application Status'}
      subtitle={subtitle}
      content={
        <JobPostStatusFilterContent
          applicationStatuses={modalFilters?.applicationStatuses}
          toggleApplicationStatus={toggleApplicationStatus}
        />
      }
    />
  );
};

type JobPostStatusFilterContentProps = {
  applicationStatuses: JobPostStatusType[] | undefined;
  toggleApplicationStatus: (applicationStatus: JobPostStatusType) => void;
};
const JobPostStatusFilterContent = ({
  applicationStatuses,
  toggleApplicationStatus,
}: JobPostStatusFilterContentProps) => {
  const loggedInUserId = useSelector(
    (state: RootState) => state.app?.user?.profile?.id
  );

  const isLoggedIn = useMemo(() => !!loggedInUserId, [loggedInUserId]);
  return (
    <StyledChipsContainer applyMobileWidthReduction>
      {JOB_POST_STATUS_OPTIONS.filter((jobPostStatus) => {
        if (jobPostStatus.value === 'submitted' && !isLoggedIn) {
          return false;
        }
        return true;
      }).map((jobPostStatus) => (
        <ChipSelectOption
          key={`jobs-board-filter-job-post-status-${jobPostStatus.value}`}
          label={jobPostStatus.label}
          isSelected={
            applicationStatuses?.includes(jobPostStatus.value) ?? false
          }
          onClick={() => toggleApplicationStatus(jobPostStatus.value)}
        />
      ))}
    </StyledChipsContainer>
  );
};
